import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import { Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { RootState } from '../../reducers';
import './Aside.scss';
import * as actions from '../../actions/index';
import { ReactComponent as IconInnovation } from '../../assets/icons/e_i_innovation.svg';
import { formatNumber } from '../../utils/react';
import SpinnerV2 from '../SpinnerV2';
import { Button, EButtonType } from '@repo/apg-ui';
import { ReactComponent as CloseIcon } from '../../assets/icons/new/close.svg';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';

interface Props {
  locales: any;
  intl: any;
  userData: any;
  modal: boolean;
  history: any;
  step: number;
  total?: number;
  loading: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  industry: any;
  industriesByKey: any;
  closeAside?: any;
}

const Aside = ({ total, intl, modal, closeAside, userDataEC, loading }: Props) => {
  const getUrlByLocale = () => {
    const LINKS = {
      de: 'https://www.apgsga.ch/de/aussenwerbung/plakate-online-buchen#Leitfaden',
      en: 'https://www.apgsga.ch/en/aussenwerbung/plakate-online-buchen#Guide',
      fr: 'https://www.apgsga.ch/fr/aussenwerbung/plakate-online-buchen#Guide',
      it: 'https://www.apgsga.ch/it/aussenwerbung/plakate-online-buchen#Guida',
    };
    return LINKS[intl.locale];
  };

  const renderAdvisor = () => {
    return (
      <div className='advisor'>
        <div className='d-flex flex-row align-items-center justify-content-between mb-24'>
          <p className='fw-bold mb-0'>
            <FormattedMessage id='ec.modal.serviceDesk' defaultMessage='ServiceDesk' />
          </p>
          <div className='close-icon ms-3 cursor-pointer' onClick={() => closeAside(false)}>
            <CloseIcon />
          </div>
        </div>
        <p className='mb-40'>
          <FormattedMessage
            id='ec.modal.fragen'
            defaultMessage='Bei Fragen kontaktieren Sie bitte unsere Beraterinnen und Berater.'
          />
        </p>
        <p className='timing-title mb-0'>
          <FormattedMessage id='ec.modal.offnungszeiten' defaultMessage='Öffnungszeiten' />
        </p>
        <p className='mb-0'>
          <FormattedMessage id='ec.modal.montagFreitag' defaultMessage='Montag - Freitag' />
        </p>
        <p className='mb-0'>
          <FormattedMessage id='ec.modal.time' defaultMessage='08:00 Uhr - 12:00 Uhr' />
        </p>
        <p className='mb-4'>
          <FormattedMessage id='ec.modal.timeTwo' defaultMessage='13:00 Uhr - 17:00 Uhr' />
        </p>
        <a href='tel:+41 58 220 77 77'>
          <p className='mb-0'>
            <FormattedMessage id='ec.modal.phoneOne' defaultMessage='T +41 58 220 77 77' />
          </p>
        </a>
        <a href='tel:+41 58 220 70 97'>
          <p className='mb-0'>
            <FormattedMessage id='ec.modal.phoneTwo' defaultMessage='F +41 58 220 70 97' />
          </p>
        </a>
        <a href='mailto:servicedesk@apgsga.ch'>
          <p className='mb-0 color-red fw-bold'>
            <FormattedMessage id='ec.modal.mail' defaultMessage='servicedesk@apgsga.ch' />
          </p>
        </a>
      </div>
    );
  };

  const renderPreTotal = () => {
    const basketInfo = userDataEC.basketInfo;

    return basketInfo ? (
      <div className='total pretotal'>
        <p className='fw-bold title mb-4'>
          <FormattedMessage id='faq.totalSum' defaultMessage='Gesamtsumme' />
        </p>

        <div className='d-flex justify-content-between mb-4'>
          <p className='fw-bold normal-text'>
            <FormattedMessage id='faq.totalBrutto' defaultMessage='Total Medialeistung brutto' />
          </p>
          <p className='fw-bold normal-text white-space-nowrap'>
            {loading.basket ? (
              <SpinnerV2 relative inText />
            ) : (
              basketInfo.totalsum && (
                <>
                  {` ${formatNumber(basketInfo.totalsum, 2)}`}&nbsp;
                  <FormattedMessage id='faq.chf' defaultMessage='CHF' />
                </>
              )
            )}
          </p>
        </div>

        {basketInfo.tax && (
          <div className='d-flex justify-content-between mb-4'>
            <p className='fw-bold normal-text'>
              <FormattedMessage id='faq.mwst' defaultMessage='MwSt. ' />
            </p>

            <p className='normal-text white-space-nowrap'>
              {loading.basket ? (
                <SpinnerV2 relative inText />
              ) : basketInfo.tax ? (
                `${formatNumber(basketInfo.tax, 2)} CHF`
              ) : (
                '?'
              )}
            </p>
          </div>
        )}

        <p className='normal-text'>
          <IconInnovation className='me-3' />
          <FormattedMessage
            id='faq.discountsShownLater'
            defaultMessage='Allfällige Rabatte werden auf der Zahlungsseite ausgewiesen.'
          />
        </p>
      </div>
    ) : null;
  };

  const renderTotal = () => {
    const basketInfo = userDataEC.basketInfo;
    return basketInfo ? (
      <div className='total'>
        <p className='fw-bold title mb-4'>
          <FormattedMessage id='faq.totalSum' defaultMessage='Gesamtsumme' />
        </p>

        <div className='d-flex justify-content-between mb-4'>
          <p className='fw-bold normal-text'>
            <FormattedMessage id='faq.totalBrutto' defaultMessage='Total Medialeistung brutto' />
          </p>

          <p className='fw-bold normal-text white-space-nowrap'>
            {loading.basket ? (
              <SpinnerV2 relative inText />
            ) : (
              basketInfo.mediasum && (
                <>
                  {` ${formatNumber(basketInfo.mediasum, 2)}`}&nbsp;
                  <FormattedMessage id='faq.chf' defaultMessage='CHF' />
                </>
              )
            )}
          </p>
        </div>

        {basketInfo.discount !== 0 && (
          <div className='mb-4'>
            <div className='d-flex justify-content-between'>
              <div className='d-flex flex-column'>
                <p className='normal-text'>{basketInfo.discountlabel ? basketInfo.discountlabel : ''}</p>
                {basketInfo.discountsublabel && <p className='small-text'>{basketInfo.discountsublabel}</p>}
              </div>

              <p className='normal-text white-space-nowrap'>
                {basketInfo.discount && (
                  <>
                    {formatNumber(basketInfo.discount, 2)}&nbsp;
                    <FormattedMessage id='faq.chf' defaultMessage='CHF' />
                  </>
                )}
              </p>
            </div>
          </div>
        )}

        <div className='d-flex justify-content-between mb-4'>
          <p className='fw-bold normal-text'>
            {basketInfo.agencyprovision && basketInfo.discount ? (
              <FormattedMessage id='faq.totalNetAgency' defaultMessage='Total netto' />
            ) : (
              <FormattedMessage id='faq.totalNet' defaultMessage='Total netto/netto' />
            )}
          </p>

          <p className='fw-bold normal-text white-space-nowrap'>
            {loading.basket ? (
              <SpinnerV2 relative inText />
            ) : basketInfo.mediasum ? (
              formatNumber(basketInfo.mediasum - basketInfo.discount, 2) + ' CHF'
            ) : (
              '?'
            )}
          </p>
        </div>

        {basketInfo.agencyprovision && (
          <div className='mb-4'>
            <div className='d-flex justify-content-between'>
              <div className='d-flex flex-column'>
                <p className='normal-text'>{basketInfo.provisionlabel ? basketInfo.provisionlabel : ''}</p>
                {basketInfo.provisionsublabel && <p className='small-text'>{basketInfo.provisionsublabel}</p>}
              </div>

              <p className='normal-text white-space-nowrap'>
                {basketInfo.agencyprovision && (
                  <>
                    {formatNumber(basketInfo.agencyprovision, 2)}&nbsp;
                    <FormattedMessage id='faq.chf' defaultMessage='CHF' />
                  </>
                )}
              </p>
            </div>
          </div>
        )}

        {basketInfo.agencyprovision && (
          <div className='d-flex justify-content-between mb-4'>
            <p className='fw-bold normal-text'>
              <FormattedMessage id='faq.totalNet' defaultMessage='Total netto/netto' />
            </p>

            <p className='fw-bold normal-text'>
              {loading.basket ? (
                <SpinnerV2 relative inText />
              ) : basketInfo.agencyprovision ? (
                formatNumber(
                  basketInfo.mediasum - basketInfo.agencyprovision - (basketInfo.discount ? basketInfo.discount : 0),
                  2,
                ) + ' CHF'
              ) : (
                '?'
              )}
            </p>
          </div>
        )}

        <div className='d-flex justify-content-between mb-4'>
          <p className='normal-text'>
            <FormattedMessage id='faq.mwst' defaultMessage='MwSt. ' />
          </p>

          <p className='normal-text white-space-nowrap'>
            {loading.basket ? (
              <SpinnerV2 relative inText />
            ) : basketInfo.tax ? (
              formatNumber(basketInfo.tax, 2) + ' CHF'
            ) : (
              '?'
            )}
          </p>
        </div>

        <div className='d-flex justify-content-between mb-4'>
          <div className='d-flex flex-column'>
            <p className='fw-bold normal-text'>
              <FormattedMessage id='faq.totalIncludingMwwst' defaultMessage='Total inkl. MwSt.' />
            </p>
          </div>

          <p className='fw-bold normal-text white-space-nowrap'>
            {loading.basket ? (
              <SpinnerV2 relative inText />
            ) : (
              <>
                {` ${formatNumber(basketInfo.totalsum, 2)}`}&nbsp;
                <FormattedMessage id='faq.chf' defaultMessage='CHF' />
              </>
            )}
          </p>
        </div>
      </div>
    ) : null;
  };

  return (
    <div className='aside'>
      {total === 1 ? renderPreTotal() : total === 2 ? renderTotal() : null}

      <aside className='asideContainer'>
        {renderAdvisor()}

        <div className='goodToKnow mt-48'>
          <p className='sub-title fw-bold mb-0 mt-2'>
            <FormattedMessage id='ec.modal.gutZuWissen' defaultMessage='Gut zu wissen' />
          </p>

          <Button href={getUrlByLocale()} target='_blank' buttonType={EButtonType.BasicLink} className='color-red'>
            <p className='mb-0 color-red fw-bold'>
              <FormattedMessage id='ec.modal.leitfadenOnlinePlanung' defaultMessage='Leitfaden APGISGA easy' />
            </p>
          </Button>
        </div>

        <div className='mt-5'>
          <b>
            <FormattedMessage id='ec.hilfe.extrainfo.header' defaultMessage='Plakat- und Spotproduktion' />
          </b>
          <p className='pt-3'>
            <FormattedMessage
              id='ec.hilfe.extrainfo.text'
              defaultMessage='Für den Plakatdruck und die Spot-Produktion können Sie nach Abschluss Ihrer Buchung auf Wunsch einen geeigneten Produktions-Partner wählen.'
              values={{ b: (chunks: any) => <b>{chunks}</b> }}
            />
          </p>
        </div>
      </aside>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    logOut: () => dispatch(actions.logOut()),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Aside)));
